import { render, staticRenderFns } from "./ListagemUsuarioHeader.vue?vue&type=template&id=e01f1d1c"
import script from "./ListagemUsuarioHeader.vue?vue&type=script&lang=js"
export * from "./ListagemUsuarioHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports